import { put } from 'redux-saga/effects';
import { HandleQueuedActionsAction } from 'smartHome/larva/types/redux/larvaActions';

export function* handleQueuedActions({ payload: actions }: HandleQueuedActionsAction): Generator {
    for (const action of actions) {
        yield put(action);
    }
}
